import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Group",
  "use": "Group-usage",
  "viewBox": "0 0 22 17",
  "content": "<symbol viewBox=\"0 0 22 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Group\">\r\n<g id=\"Group_Group\">\r\n<path id=\"Group_Vector\" d=\"M12 4.5C12 2.29 10.21 0.5 8 0.5C5.79 0.5 4 2.29 4 4.5C4 6.71 5.79 8.5 8 8.5C10.21 8.5 12 6.71 12 4.5ZM14 6.5V8.5H17V11.5H19V8.5H22V6.5H19V3.5H17V6.5H14ZM0 14.5V16.5H16V14.5C16 11.84 10.67 10.5 8 10.5C5.33 10.5 0 11.84 0 14.5Z\" fill=\"#3A3A3A\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol